import {
  Button,
  Modal,
  type ModalProps,
  Typography,
} from '@omnipresentgroup/design-system';

const TITLE = 'Tax rate mismatches';
const DESCRIPTION =
  'There are discrepancies between the tax rates of the Xero account codes and the invoice categories. Changes will be applied regardless of the mismatch.';
const CONFIRMATION_BUTTON_LABEL = 'Confirm';
const CANCEL_BUTTON_LABEL = 'Cancel';

type XeroCongratsModalProps = {
  modalProps: Omit<ModalProps, 'children'>;
  handleClose: () => void;
  onConfirm: () => void;
};

export const XeroTaxRatesMismatchModal = ({
  modalProps,
  onConfirm,
  handleClose,
}: XeroCongratsModalProps) => {
  return (
    <Modal {...modalProps} span={3}>
      <Modal.Header title={TITLE} onClose={handleClose} />
      <Modal.Body>
        <Typography as="span" size="14">
          {DESCRIPTION}
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {CANCEL_BUTTON_LABEL}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            handleClose();
          }}
        >
          {CONFIRMATION_BUTTON_LABEL}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
